export default __webpack_public_path__ + "static/filedblob-a560b6928f41c96f5b19a840d6aa923d.png";